/**
 * Type de comparaison effectué sur une valeur d'un attribut.
 */
export enum ComparisonType {
    /* Egalité.*/
    Equal,
    /* Inégalité.*/
    NotEqual,
    /* Inférieur.*/
    LessThan,
    /* Inférieur ou égale.*/
    LessOrEqual,
    /* Supérieur.*/
    GreaterThan,
    /* Supérieur ou égale.*/
    GreaterOrEqual,
}
